import React from 'react';
import { string, func, bool, node } from 'prop-types';
import { Avatar, Hyperlink } from '../../Atoms';
import { LogoCardWithTextWrapper, LogoCardWithTextContainer, IconWrapper } from './LogoCardWithText.styles';
export const LogoCardWithText = _ref => {
  let {
    avatarUrl,
    title,
    subtitle,
    action,
    href,
    hasBackground,
    hasRoundedAvatar,
    isSubtitleShortened,
    icon
  } = _ref;
  const getShortenedSubtitle = () => subtitle.split(',')[0] || subtitle;
  const renderContent = () => {
    return /*#__PURE__*/React.createElement(LogoCardWithTextWrapper, {
      icon: icon,
      avatarUrl: avatarUrl,
      hasBackground: hasBackground,
      hasRoundedAvatar: hasRoundedAvatar
    }, avatarUrl ? /*#__PURE__*/React.createElement(Avatar, {
      size: "small",
      imageUrl: avatarUrl,
      imageAlt: title,
      backgroundColor: "white"
    }) : /*#__PURE__*/React.createElement(IconWrapper, null, icon), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("h2", {
      className: "title"
    }, title), subtitle && /*#__PURE__*/React.createElement("div", {
      className: "sub-title"
    }, isSubtitleShortened ? getShortenedSubtitle() : subtitle)));
  };
  return /*#__PURE__*/React.createElement(LogoCardWithTextContainer, null, action || href ? /*#__PURE__*/React.createElement(Hyperlink, {
    onClick: event => action ? action(event) : undefined,
    href: href,
    target: "_blank"
  }, renderContent()) : /*#__PURE__*/React.createElement("div", {
    "data-test-id": "card"
  }, renderContent()));
};
LogoCardWithText.propTypes = {
  avatarUrl: string,
  title: string.isRequired,
  subtitle: string,
  action: func,
  href: string,
  hasBackground: bool,
  hasRoundedAvatar: bool,
  isSubtitleShortened: bool,
  icon: node
};
LogoCardWithText.defaultProps = {
  avatarUrl: undefined,
  subtitle: undefined,
  action: undefined,
  href: undefined,
  hasBackground: false,
  hasRoundedAvatar: true,
  isSubtitleShortened: false,
  icon: undefined
};